import { render, staticRenderFns } from "./bo-bundle-deal-link.vue?vue&type=template&id=725426c4"
import script from "./bo-bundle-deal-link.vue?vue&type=script&lang=js"
export * from "./bo-bundle-deal-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports